import { supabase } from 'lib/supabase';

export type ChangelogItemType = 'new_feature' | 'improvement' | 'bug_fix';
export type ChangelogPlatform = 'all' | 'ios' | 'android';

export interface ChangelogItem {
  id: number;
  type: ChangelogItemType;
  text: string;
  platform: ChangelogPlatform;
}

export interface ChangelogEntry {
  id: number;
  version: string;
  // Unix timestamp in seconds for the start of the release month
  release_month: number;
  changelog_entry_items: ChangelogItem[];
}

// RLS only returns published entries (and their items) to the public key,
// but filter here too so the intent is clear.
export const fetchChangelog = async (): Promise<ChangelogEntry[]> => {
  const { data, error } = await supabase
    .from('changelog_entries')
    .select('id, version, release_month, changelog_entry_items(id, type, text, platform)')
    .eq('is_published', true)
    .order('release_month', { ascending: false })
    .order('id', { ascending: false })
    .order('id', { referencedTable: 'changelog_entry_items', ascending: true });

  if (error) throw error;
  return (data ?? []) as ChangelogEntry[];
};

// en-US gives "Sep 2026" like the app; en-AU would give "Sept 2026"
export const formatReleaseMonth = (unixSeconds: number) =>
  new Date(unixSeconds * 1000).toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' });

// YYYY-MM for the <time> element's machine-readable date
export const releaseMonthIso = (unixSeconds: number) => new Date(unixSeconds * 1000).toISOString().slice(0, 7);
